import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Analytics } from '@trello/atlassian-analytics';
import { siteDomain } from '@trello/config';
import { Button } from '@trello/nachos/button';
import { Popover, usePopover } from '@trello/nachos/popover';
import type { PIIString } from '@trello/privacy';

import { ShareTemplatePopover } from 'app/src/components/ShareTemplatePopover';

import styles from './TemplateShareButton.less';

export const TemplateShareButton: FunctionComponent<{
  boardId: string;
  storyPageUrl: string;
  name: string;
  username?: PIIString;
}> = ({ boardId, storyPageUrl, name, username }) => {
  const { triggerRef, popoverProps, toggle } = usePopover<HTMLButtonElement>();
  const shareTemplateOnClick = () => {
    toggle();

    Analytics.sendClickedButtonEvent({
      buttonName: 'shareButton',
      source: 'templateStoryPageScreen',
    });
  };

  return (
    <>
      <Button
        className={styles.button}
        ref={triggerRef}
        onClick={shareTemplateOnClick}
      >
        <FormattedMessage
          id="templates.templates.share"
          defaultMessage="Share"
          description="The text of the button used to share a template"
        />
      </Button>
      <Popover
        {...popoverProps}
        title={
          <FormattedMessage
            id="templates.templates.share"
            defaultMessage="Share"
            description="The text of the button used to share a template"
          />
        }
      >
        <ShareTemplatePopover
          storyPageUrl={`${siteDomain}${storyPageUrl}`}
          username={username}
          // we filter out non public gallery templates in the API
          visibility={'public'}
          name={name}
          boardId={boardId}
        />
      </Popover>
    </>
  );
};
